var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosedS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.5H1V4.5H0V3.5ZM2 5.5H1V4.5H2V5.5ZM4 6.5V5.5H2V6.5H1V7.5H2V6.5H4ZM8 6.5H4V7.5H3V8.5H4V7.5H8V8.5H9V7.5H8V6.5ZM10 5.5H8V6.5H10V7.5H11V6.5H10V5.5ZM11 4.5V5.5H10V4.5H11ZM11 4.5V3.5H12V4.5H11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosedS);
export default __webpack_public_path__ + "static/media/eye-closed-s.6e92acf03c70362aefb6204cfcc7abb1.svg";
export { ForwardRef as ReactComponent };